import { createApiRequest } from '@/utils/services';

export const DEFAULT_FETCH_ORG_LIMIT = 1000;
export const buildOrgListPath = (limit, page) => {
  let path = 'orgs';

  if (limit) {
    path = `${path}?limit=${limit}`;

    if (page) {
      path = `${path}&page=${page}`;
    }
  }

  return path;
};

export const getOrgList = (limit, page) => {
  return createApiRequest({
    method: 'get',
    path: buildOrgListPath(limit, page),
    throwErrors: true,
  });
};

export const createOrg = (data) =>
  createApiRequest({
    method: 'post',
    path: 'orgs',
    data,
    throwErrors: true,
  });

export const getOrgInfo = (ownerOrgPubId) =>
  createApiRequest({
    method: 'get',
    path: `orgs/${ownerOrgPubId}`,
    throwErrors: true,
  });

export const updateOrgInfo = (ownerOrgPubId, data) =>
  createApiRequest({
    data,
    method: 'put',
    path: `orgs/${ownerOrgPubId}`,
    throwErrors: true,
  });

export const orgsService = {
  createOrg,
  getOrgList,
  getOrgInfo,
  updateOrgInfo,
};

export default orgsService;
